import { Platform, PlatformerLevel } from '../../shared/CharacterTypes';
import { MAP_DEFAULTS } from '../../config/map/defaults.config';
import { GridLevel, LayerType } from '../../shared/TileEditorTypes';
import { W, H, T } from './StarterMap';

const MAP_ID = 'multiplayer-observe';
const MAP_NAME = 'Multiplayer Observation Grounds';
const VERSION = '1.0';

const groundLayer = new Map<string, number>();
const collisionLayer = new Map<string, number>();
const objectsLayer = new Map<string, number>();
const entitiesLayer = new Map<string, number>();
const triggersLayer = new Map<string, number>();

const entities: any[] = [];

export const OBSERVATION_GROUND_Y = 660;
export const OBSERVATION_SPAWN_X = 640;
export const OBSERVATION_SPAWN_Y = 620;

const spawnPoints = [
  { x: OBSERVATION_SPAWN_X / T, y: OBSERVATION_SPAWN_Y / T }
];

const defaultSpawn = {
  x: OBSERVATION_SPAWN_X,
  y: OBSERVATION_SPAWN_Y
};


const runtimePlatforms: Platform[] = [
  {
    id: 'observation-ground',
    x: 0,
    y: OBSERVATION_GROUND_Y,
    width: W * T,
    height: 40,
    type: 'normal' as const,
    color: '#3b4758'
  }
];

export const MultiplayerObserveMap: GridLevel & Partial<PlatformerLevel> = {
  id: MAP_ID,
  name: MAP_NAME,
  version: VERSION,
  widthTiles: W,
  heightTiles: H,
  width: W * T,
  height: H * T,
  tileSize: T,
  backgroundColor: '#8fc7df',
  gravity: MAP_DEFAULTS.gravity,

  spawnPoints,
  defaultSpawn,

  layers: [
    {
      name: LayerType.GROUND,
      visible: true,
      locked: false,
      opacity: 1.0,
      tiles: groundLayer
    },
    {
      name: LayerType.COLLISION,
      visible: true,
      locked: false,
      opacity: 1.0,
      tiles: collisionLayer
    },
    {
      name: LayerType.OBJECTS,
      visible: true,
      locked: false,
      opacity: 1.0,
      tiles: objectsLayer
    },
    {
      name: LayerType.ENTITIES,
      visible: true,
      locked: false,
      opacity: 1.0,
      tiles: entitiesLayer,
      entities
    },
    {
      name: LayerType.TRIGGERS,
      visible: true,
      locked: false,
      opacity: 1.0,
      tiles: triggersLayer
    }
  ],

  platforms: runtimePlatforms,
  spawnRules: [],
  type: 'field',
  metadata: {
    author: 'Helix2000 System',
    description: 'A low-clutter built-in map for multiplayer observation, screenshots, and render-state verification.',
    difficulty: 'Low',
    maxPlayers: 10,
    version: VERSION,
    tags: ['multiplayer', 'diagnostics', 'observation']
  }
};
